import React from 'react'
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import Header from '@/components/Header'
import HomePage from '@/pages/HomePage'
import TherapyPage from '@/pages/TherapyPage'
import ConditionsPage from '@/pages/ConditionsPage'
import AssessmentPage from '@/pages/AssessmentPage'
import ResourcesPage from '@/pages/ResourcesPage'
import SavedArticlesPage from '@/pages/SavedArticlesPage'
import ContactPage from '@/pages/ContactPage'

function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-bold text-[#4A90E2] mb-4">Anxiety USA</h3>
            <p className="text-gray-600 text-sm">
              Your trusted resource for understanding and managing anxiety in America.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-gray-900 mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/therapy" className="text-gray-600 hover:text-[#48C9B0]">Find a Therapist</Link></li>
              <li><Link to="/assessment" className="text-gray-600 hover:text-[#48C9B0]">Take GAD-7 Test</Link></li>
              <li><Link to="/conditions" className="text-gray-600 hover:text-[#48C9B0]">Anxiety Types</Link></li>
              <li><Link to="/contact" className="text-gray-600 hover:text-[#48C9B0]">Contact Us</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-gray-900 mb-4">Disclaimer</h4>
            <p className="text-gray-600 text-xs">
              This website provides educational information only and is not a substitute for professional medical advice, diagnosis, or treatment.
            </p>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-200 text-center text-sm text-gray-500">
          © {new Date().getFullYear()} Anxiety USA. All rights reserved.
        </div>
      </div>
    </footer>
  )
}

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white flex flex-col">
        <Header />
        <main id="main-content" className="flex-grow" role="main" tabIndex={-1}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/therapy" element={<TherapyPage />} />
            <Route path="/conditions" element={<ConditionsPage />} />
            <Route path="/assessment" element={<AssessmentPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/saved" element={<SavedArticlesPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App
